import * as React from 'react';

import Typography from 'shared/newComponents/Typography';
import {
  TypographyType,
  TypographySize,
  TypographyColor,
  TypographyWeight
} from 'shared/newEntities/components/Typography';
import { useUiStore } from 'stores';
import { useChannelsModalStore } from 'stores/ChannelsModalStore';
import { ComponentType } from 'shared/entities/components/Component';
import { ButtonColor, ButtonSize } from 'shared/newEntities/components/Button';
import { Button } from 'shared/newComponents/buttons';
import { PlusIcon } from 'shared/newComponents/icons';
import { MobileChannelsModalTab } from 'shared/entities/channels';
import Reference from 'shared/newComponents/Reference';
import { useSmartbotAIConnectionStore } from 'stores/smartbotAI/SmartbotAIConnectionStore';
import { PopupPosition } from 'shared/entities/components/Popup';

import LinkedReference from '../LinkedReference';

import './Header.modules.scss';

type Props = {
  className?: string;
};

const Header: React.FC<Props> = ({ className }) => {
  const uiStore = useUiStore();
  const { store } = useChannelsModalStore();
  const connectionStore = useSmartbotAIConnectionStore();

  const handleClick = React.useCallback(() => {
    store.selectTab(MobileChannelsModalTab.createChannel);
  }, []);

  if (store.bot) {
    return (
      <div styleName="header_with-bot">
        <div styleName="header__title">
          <Typography
            fontType={TypographyType.text}
            fontSize={TypographySize.m}
            fontColor={TypographyColor.main}
            fontWeight={TypographyWeight.heavy}
          >
            {(t) =>
              t('ChannelsModal.ChannelTable.Header.title', {
                ns: 'newContainers'
              })
            }
          </Typography>
          {connectionStore.scenarios.length > 1 && (
            <Reference
              position={PopupPosition.rightCenter}
              title={(t) =>
                t('ChannelsModal.ChannelTable.Header.hint', {
                  ns: 'newContainers'
                })
              }
            />
          )}
        </div>
        <Button
          Icon={PlusIcon}
          size={ButtonSize.xs}
          type={ComponentType.button}
          color={ButtonColor.lightBlue}
          onClick={handleClick}
          styleName="header__button"
          transparentBorder
        >
          {(t) =>
            t('ChannelsModal.ChannelTable.Header.button', {
              ns: 'newContainers'
            })
          }
        </Button>
      </div>
    );
  }

  return (
    <div styleName="header" className={className}>
      <Typography
        fontType={TypographyType.text}
        fontSize={TypographySize.s}
        fontColor={TypographyColor.secondary}
        styleName="header__name"
      >
        {(t) =>
          t('ChannelsModal.ChannelTable.Header.name', {
            ns: 'newContainers'
          })
        }
      </Typography>
      {!uiStore.isMobileSize && (
        <>
          {store.withAccounts && (
            <div styleName="header__item">
              <Typography
                fontType={TypographyType.text}
                fontSize={TypographySize.s}
                fontColor={TypographyColor.secondary}
              >
                {(t) =>
                  t('ChannelsModal.ChannelTable.Header.linked', {
                    ns: 'newContainers'
                  })
                }
              </Typography>
              <LinkedReference />
            </div>
          )}
          <div styleName="header__item">
            <Typography
              fontType={TypographyType.text}
              fontSize={TypographySize.s}
              fontColor={TypographyColor.secondary}
            >
              {(t) =>
                t('ChannelsModal.ChannelTable.Header.enabled', {
                  ns: 'newContainers'
                })
              }
            </Typography>
          </div>
          <div styleName="header__stub" />
        </>
      )}
      {uiStore.isMobileSize && (
        <Typography
          fontType={TypographyType.text}
          fontSize={TypographySize.s}
          fontColor={TypographyColor.secondary}
          styleName="header__item"
        >
          {(t) =>
            t(
              `ChannelsModal.ChannelTable.Header.${
                store.withAccounts
                  ? 'mobileHeaderWithAccount'
                  : 'mobileHeaderWithoutAccount'
              }`,
              {
                ns: 'newContainers'
              }
            )
          }
        </Typography>
      )}
    </div>
  );
};

export default Header;
